/**
 * Get user initials from full name
 * @param {string} name - User's full name
 * @returns {string} User initials (1 or 2 characters)
 */
export const getUserInitials = (name) => {
  if (!name) return 'U';
  const nameParts = name.trim().split(' ');
  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  }
  return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
};

